import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const RouteAnalytics = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.gtag) window.gtag("event", "page_view", { page_path: pathname, page_location: window.location.href });
  }, [pathname]);
  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (a && window.gtag) {
        window.gtag("event", "phone_call_click", {
          phone: a.getAttribute("href").replace("tel:", ""),
          page_path: window.location.pathname,
        });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);
  return null;
};
